import React from 'react';
import { withRouter } from 'react-router-dom';

import { PeriodList } from 'components/Subscriptions';
import Layout from 'components/Layout';
import i18n from 'i18n-js';

const PeriodsList = ({ history }) => {
  return (
    <Layout title={i18n.t('subscriptions.reservation_periods')}>
      <PeriodList history={history} title={i18n.t('subscriptions.reservation_periods')} />
    </Layout>
  );
};

export default withRouter(PeriodsList);
